export const TRANSLATIONS_GLOBAL = {
  tooltip: 'global.tooltip.select_all_rows',
  collaborators: {
    title: 'global.collaborators.title',
    addCollraborators: 'csp.add_collaborators',
    header: {
      title: 'collaborators_detail.header.title',
      description: 'collaborators_detail.header.description'
    },
    details: {
      index: 'collaborators_detail.index',
      tooltip: 'tooltip.collaborators.detail_collaborators'
    },
    management: {
      index: 'add_remove_collaborators.index',
      tooltip: 'tooltip.collaborators.add_remove_collaborators'
    },
    canceledSubscriptions: {
      index: 'canceled_subscriptions.index',
      tooltip: 'tooltip.collaborators.remove_collaborators'
    },
    requestDetail: {
      index: 'csp.requests_list',
      tooltip: 'tooltip.collaborators.request_panel'
    },
    history: {
      index: 'csp.history',
      tooltip: 'tooltip.collaborators.remove_collaborators'
    }
  },
  modals: {
    masiveEmail: {
      expression: 'modal.expression.attention',
      title: 'modal.send_email.title',
      description: 'modal.send_email.description',
      primaryButton: 'button.send_all',
      secondaryButton: 'button.cancel'
    },
    generic: {
      title: 'modal.expression.sorry',
      subtitle: 'csp.error.we_need_a_moment',
      description: 'modal.error.generic',
      primaryButton: 'button.retry'
    },
    onboardingEmail: {
      expression: 'modal.expression.attention',
      title: 'modal.send_email.title',
      description: 'modal.monthly_email.content',
      primaryButton: 'button.send',
      secondaryButton: 'button.cancel'
    },
    subscription: {
      expression: 'modal.expression.attention',
      title: 'modal.subtitle.add_collaborators',
      description: 'modal.add_remove_collaborators.content',
      primaryButton: 'button.accept',
      secondaryButton: 'button.cancel'
    },
    unsubscription: {
      expression: 'modal.expression.attention',
      title: 'modal.remove_collaborators.subtitle',
      description: 'modal.add_remove_collaborators.content',
      primaryButton: 'button.accept',
      secondaryButton: 'button.cancel'
    },
    customeBenefitsUpselling: {
      expression: 'benefits.custom.category_tag',
      title: 'modal.custom_benefit.upsell_subtitle',
      description: 'modal.custom_benefit.upsell_content',
      primaryButton: 'button.understood'
    },
    collaboratorsFatalError: {
      titleAdd: 'modal.request_incomplete.add.title',
      titleRemove: 'modal.request_incomplete.remove.title',
      description: 'modal.request_incomplete.content',
      primaryButton: 'button.open_support'
    },
    invitationType: {
      title: 'modal.invitation_type.title',
      description: 'modal.invitation_type.description',
      option1: {
        title: 'modal.invitation_type.option_1.title',
        description: 'modal.invitation_type.option_1.description'
      },
      option2: {
        title: 'modal.invitation_type.option_2.title',
        description: 'modal.invitation_type.option_2.description'
      },
      button: 'modal.invitation_type.button'
    },
    inviteCollaborators: {
      title: 'modal.invite_collaborators.title',
      subtitle: 'modal.invite_collaborators.subtitle',
      primaryButtonText: 'button.add_collaborators',
      primaryButtonAddDomains: 'button.add_domains',
      primaryButtonConfiguredDomins: 'button.understood',
      secondaryButtonText: 'button.go_back',
      onlyEmailTab: 'modal.invite_collaborators.only_email_tab',
      domainTab: 'modal.invite_collaborators.domain_tab',
      fileTab: 'add_collaborator.ne.segment_3',
      planSelector: {
        title: 'modal.invite_collaborators.plan_selector.title',
        titleAddDomains: 'modal.invite_collaborators.plan_selector.title_add_domains'
      }
    },
    inviteCollaboratorsTextArea: {
      textAreaDescription: 'modal.email_textarea.description',
      placeholder: 'modal.email_textarea.placeholder',
      textAreaErrorMessage: 'modal.email_textarea.error_message'
    },
    inviteCollaboratorsTextAreaV3: {
      textAreaDescription: 'input_emails.placeholder',
      emailFormatError: 'input_email.error.format',
      emailNotFound: 'input_email.error.not_registered'
    },
    inviteCollaboratorsSuccess: {
      title: 'modal.invite_collaborators.success.title',
      description: 'modal.invite_collaborators.success.description',
      primaryButtonText: 'button.explore_portal',
      secondaryButtonText: 'button.go_collaborators',
      slack: {
        description: 'modal.invite_collaborators.success.slack.description',
        primaryButtonText: 'button.slack_connection',
        secondaryButtonText: 'button.skip',
        title: 'modal.invite_collaborators.success.slack.title'
      }
    },
    inviteCollaboratorsLicensesError: 'add_collaborator.ne.form.error_max_licenses',
    inviteCollaboratorsPlanError: {
      title: 'add_collaborator.ne.upload.error_tible',
      subtitle: 'add_collaborator.ne.upload.error_subtible'
    },
    inviteCollaboratorsError: {
      title: 'modal.invite_collaborators.error.title',
      description: 'modal.invite_collaborators.error.description',
      primaryButtonText: 'button.retry'
    },
    inviteCollaboratorsByDomain: {
      enterDomainTitle: 'modal.invite_collaborators_by_domain.enter_domain_title',
      enterDomainAlert: 'modal.invite_collaborators_by_domain.enter_domain_alert',
      addDomainButton: 'modal.invite_collaborators_by_domain.add_domain_button',
      deleteDomainButton: 'modal.invite_collaborators_by_domain.delete_domain_button',
      configuredPlan: 'modal.invite_collaborators_by_domain.configured_plan',
      configuredDomains: 'modal.invite_collaborators_by_domain.configured_domains',
      warningMessage: 'modal.invite_collaborators_by_domain.warning_message',
      isMailProviderMessage: 'modal.invite_collaborators_by_domain.is_mail_provider_message',
      domainExplanation: 'modal.invite_collaborators_by_domain.domain_explanation',
      configuredPlanMessage: 'modal.invite_collaborators_by_domain.configured_plan_message',
      needChangeDomains: 'modal.invite_collaborators_by_domain.need_change_domains',
      domainAlreadyAssigned: 'modal.invite_collaborators_by_domain.domain_already_assigned',
      genericDomainsNotAllowed: 'modal.invite_collaborators_by_domain.generic_domains_not_allowed',
      inputError: 'modal.invite_collaborators_by_domain.input_error',
      secondaryInputError: 'modal.invite_collaborators_by_domain.secondary_input_error'
    },
    deleteDomain: {
      title: 'csp.delete_domain',
      description: 'modal.delete_domain.description',
      primaryButtonText: 'csp.delete_domain',
      secondaryButtonText: 'button.cancel'
    },
    inviteCollaboratorsByDomainSuccess: {
      title: 'modal.invite_collaborators_by_domain.success.title',
      description: 'modal.invite_collaborators_by_domain.success.description',
      secondaryDescription: 'modal.invite_collaborators_by_domain.success.secondary_description',
      primaryButtonText: 'button.slack_connection',
      secondaryButtonText: 'button.skip'
    },
    inviteCollaboratorsByFile: {
      title: 'add_collaborator.ne.form.title',
      subtitle: 'add_collaborator.ne.form.subtitle',
      download: 'add_collaborator.ne.form.button_1',
      warning: 'add_collaborator.ne.alert1',
      cardStatus: 'add_collaborator.ne.form_alert',
      toastTemplate: {
        title: 'snackbar.title.download',
        description: 'snackbar.error.download_template',
        buttonText: 'button.accept'
      },
      uploadFileError: {
        fileSize: 'add_collaborator.ne.form.error_maximum_rows',
        emptyFile: 'error_message.excel.empty_file',
        errorsFound: 'add_collaborator.ne.form.multiple_errors',
        default: 'add_collaborator.ne.form.default_error'
      },
      seeErrorsButton: 'button.view_errors'
    },
    inviteCollaboratorsErrors: {
      title: 'add_collaborator.ne.upload.headline_error',
      subtitle: 'add_collaborator.ne.upload.description_error',
      primaryButtonText: 'button.upload_corrected_file',
      error1: 'add_collaborator.ne.banner.error',
      error2: 'add_collaborator.ne.banner.error_max',
      table: {
        header: {
          id: 'csp.id',
          lastName: 'csp.first_lastname',
          secondLastName: 'csp.second_lastname',
          name: 'csp.name',
          email: 'csp.email',
          birthDate: 'csp.birth',
          gender: 'csp.gender.index'
        }
      }
    },
    upgradePlan: {
      title: 'my_plan.upgrade_plan.dialog.title',
      description: 'my_plan.upgrade.dialog.description',
      primaryButton: 'global.button.contact_me'
    },
    upgradeProtection: {
      title: 'my_plan.upgrade_protection.dialog.title',
      description: 'my_plan.upgrade.dialog.description',
      primaryButton: 'global.button.contact_me'
    },
    upgradeBenefits: {
      title: 'my_plan.upgrade_benefits.dialog.title',
      description: 'my_plan.upgrade.dialog.description',
      primaryButton: 'global.button.contact_me'
    }
  },
  sidebar: {
    home: 'sidebar_menu.home',
    metrics: {
      ne: 'global.metrics',
      default: 'global.metrics_and_reports',
      rf: 'rf.global.metrics_and_reports'
    },
    benefits: 'sidebar_menu.benefits',
    collaborators: 'sidebar_menu.collaborators',
    plan: 'sidebar_menu.my_plan',
    logout: 'sidebar_menu.logout',
    settings: 'profile_menu.title',
    communications: 'sidebar_menu.communications',
    stories: 'sidebar_menu.stories',
    points: 'sidebar_menu.points.title',
    loadBalance: 'sidebar_menu.points.balance',
    sendPoints: 'sidebar_menu.points.send_points',
    history: 'sidebar_menu.points.history',
    challenges: 'sidebar_menu.challenges',
    requests: 'global.requests.main',
    emptyCompanyCard: {
      title: 'global.pending_portal.card.title',
      description: 'pending_portal.sidebar_card.description'
    }
  },
  navbar: {
    home: 'csp.home',
    dashboard: 'csp.betterfly_effect',
    metrics: 'csp.metrics',
    benefits: 'csp.benefits',
    collaborators: 'csp.collaborators.index',
    rewards: 'csp.rewards',
    plan: 'csp.plan',
    logout: 'csp.logout',
    settings: 'profile.title',
    communications: 'csp.communications',
    stories: 'csp.stories',
    loadBalance: 'rewards.load_balance.header.breadcrumb.load_balance',
    points: 'csp.points',
    history: 'csp.history'
  },
  table: {
    errorTitleOne: 'csp.expression.oops',
    errorTitleTwo: 'modal.error.load_data',
    errorSubtitle: 'csp.empty_state.subtitle',
    button: 'button.retry'
  },
  tablePagination: {
    perPage: 'datatable.display_number.per_page',
    rows: 'datatable.display_number.rows'
  },
  paginator: {
    rowsDetail: 'global.paginator.rows_detail',
    rowsPerPage: 'global.paginator.rows_per_page'
  },
  toasts: {
    downloadCollaboratorsError: {
      title: 'snackbar.title.download_file',
      description: 'snackbar.error.download',
      buttonText: 'button.accept'
    },
    downloadAttachmentError: {
      title: 'snackbar.title.download_file',
      description: 'snackbar.error.download',
      buttonText: 'button.accept'
    },
    downloadTemplateError: {
      title: 'snackbar.title.download_file',
      description: 'snackbar.error.download',
      buttonText: 'button.accept'
    },
    uploadFileError: {
      title: 'snackbar.title.upload_file',
      description: 'snackbar.error.upload_file',
      buttonText: 'button.accept'
    },
    masiveEmailSuccess: {
      title: 'snackbar.title.email_sent',
      description: 'snackbar.success.send_massive_email',
      buttonText: 'button.accept'
    },
    masiveEmailError: {
      title: 'snackbar.title.email_sent',
      description: 'snackbar.error.massive_email',
      buttonText: 'button.accept'
    },
    onboardingEmail: {
      title: 'snackbar.title.email_sent',
      description: 'snackbar.success.send_email.collaborator',
      buttonText: 'button.accept'
    },
    editBenefitCustomSuccess: {
      title: 'benefits.custom.category_tag',
      description: 'snackbar.custome_benefit.success_edition',
      buttonText: 'button.accept'
    },
    editBenefitCustomError: {
      title: 'benefits.custom.category_tag',
      description: 'snackbar.custome_benefit.error_edition',
      buttonText: 'button.accept'
    },
    createBenefitCustomSuccess: {
      title: 'benefits.custom.category_tag',
      description: 'snackbar.custome_benefit.success_creation',
      buttonText: 'button.accept'
    },
    createBenefitCustomError: {
      title: 'benefits.custom.category_tag',
      description: 'snackbar.custome_benefit.error_creation',
      buttonText: 'button.accept'
    },
    updateUserPassSuccess: {
      title: 'snackbar.title.profile.success_updated_pass',
      description: 'snackbar.profile.success_updated_pass',
      buttonText: 'button.accept'
    },
    updateCompanySuccess: {
      title: 'snackbar.title.profile.company_edition',
      description: 'snackbar.success.subtitle.profile.company_edition',
      buttonText: 'button.accept'
    },
    updateHoldingSuccess: {
      title: 'snackbar.title.profile.holding_edition',
      description: 'snackbar.success.subtitle.profile.holding_edition',
      buttonText: 'button.accept'
    },
    updateCompanyError: {
      title: 'snackbar.title.profile.company_edition',
      description: 'snackbar.error.subtitle.profile',
      buttonText: 'button.accept'
    },
    updateHoldingError: {
      title: 'snackbar.title.profile.holding_edition',
      description: 'snackbar.error.subtitle.profile',
      buttonText: 'button.accept'
    },
    signUpSuccess: {
      title: 'snackbar.title.success_signup',
      description: 'snackbar.success_signup',
      buttonText: 'button.accept'
    },
    deleteCollaboratorSuccess: {
      title: 'snackbar.title.delete_collaborator',
      description: 'snackbar.success.collaborator_deleted',
      buttonText: 'button.accept'
    },
    deleteCollaboratorError: {
      title: 'snackbar.title.delete_collaborator',
      description: 'snackbar.error.collaborator_deleted',
      buttonText: 'button.accept'
    },
    deleteCollaboratorsSuccess: {
      title: 'snackbar.title.delete_collaborators',
      description: 'snackbar.success.collaborators_deleted',
      buttonText: 'button.accept'
    },
    deleteCollaboratorsError: {
      title: 'snackbar.title.delete_collaborators',
      description: 'snackbar.error.collaborators_deleted',
      buttonText: 'button.accept'
    },
    resendEmailSuccess: {
      title: 'snackbar.title.resend_email',
      description: 'snackbar.success.email_resent',
      buttonText: 'button.accept'
    },
    resendEmailError: {
      title: 'snackbar.title.resend_email',
      description: 'snackbar.error.email_resent',
      buttonText: 'button.accept'
    },
    resendEmailsSuccess: {
      title: 'snackbar.title.resend_emails',
      description: 'snackbar.success.emails_resent',
      buttonText: 'button.accept'
    },
    resendEmailsError: {
      title: 'snackbar.title.resend_emails',
      description: 'snackbar.error.emails_resent',
      buttonText: 'button.accept'
    },
    hideStorySuccess: {
      title: 'snackbar.title.hidden_story',
      description: 'snackbar.sucess.hide_story',
      buttonText: 'button.accept'
    },
    hideStoryError: {
      title: 'snackbar.title.story_still_visible',
      description: 'snackbar.error.hide_story',
      buttonText: 'button.accept'
    },
    downloadMonthlyReportSuccess: {
      title: 'snackbar.title.download_report',
      description: 'snackbar.download_monthly_report.success',
      buttonText: 'button.accept'
    },
    downloadMonthlyReportError: {
      title: 'snackbar.title.download_error',
      description: 'snackbar.download_monthly_report.error',
      buttonText: 'button.accept'
    },
    deleteChallengeSuccess: {
      title: 'delete_challenge.toast.success'
    },
    deleteChallengeError: {
      title: 'global.toast.error.title',
      description: 'global.toast.error.description'
    },
    createChallengeSuccess: {
      title: 'create_challenge.toast.success_title',
      description: 'create_challenge.toast.success_description'
    },
    createChallengeError: {
      title: 'global.toast.error.title',
      description: 'global.toast.error.description'
    },
    downloadMembersError: {
      title: 'global.toast.error.title',
      description: 'global.toast.error.description'
    },
    genericError: {
      title: 'global.toast.error.title',
      description: 'global.toast.error.description'
    },
    downloadSubsTemplate: {
      success: {
        title: 'global.download_template.toast.success.title',
        description: 'global.download_template.toast.success.description'
      },
      error: {
        title: 'global.toast.error.title',
        description: 'global.toast.error.description'
      }
    },
    uploadSubFileError: {
      title: 'global.upload_file.error_toast.uploading_error.title',
      description: 'global.toast.error.description'
    },
    upsellRequestSuccess: {
      title: 'global.registered_request.main',
      description: 'global.contact_me.toast.description'
    },
    flexibleRemunerationNegativeBalance: {
      title: 'global.rf.balance_negative.toast.title',
      description: 'global.rf.balance_negative.toast.description'
    },
    flexibleRemunerationAlertBalance: {
      title: 'global.rf.balance_alert.toast.title',
      description: 'global.rf.balance_alert.toast.description'
    },
    addDependentsLimitError: {
      title: 'global.upload_file.error_toast.exceeded_200_rows.title',
      description: 'global.upload_file.error_toast.exceeded_rows.description'
    },
    addDependentsFormatError: {
      title: 'global.upload_file.error_toast.invalid_format.title',
      description: 'global.upload_file.error_toast.invalid_format.description',
      button: 'global.download.main'
    },
    requests: {
      approved: {
        title: 'global.approve_request.toast_success.title'
      },
      rejected: {
        title: 'global.reject_request.toast_success.title'
      },
      cancelled: {
        title: 'global.cancel_course.toast_success.title',
        insuranceTitle: 'global.cancel_insurance.toast_success.title'
      }
    },
    loginError: {
      title: 'global.toast.error.title',
      description: 'global.toast.error.description'
    }
  },
  selector: {
    company: 'csp.company',
    holding: 'csp.holding'
  },
  fileUploader: {
    error: {
      format: 'error_message.excel.format'
    },
    loading: {
      title: 'global.upload_file.loading.title',
      description: 'global.upload_file.loading.description'
    },
    fileType: 'file_uploader.import.type_file',
    or: 'csp.or',
    maxSize: 'file_uploader.import.max_size',
    dragFile: 'file_uploader.import.text_1',
    dragImage: 'benefits.custom.modal_add.drop_image',
    clickHere: 'button.click_here',
    findIt: 'file_uploader.import.text_2',
    findImage: 'benefits.custom.modal_add.to_select_it',
    dragImageNE: 'file_uploader.drag_image',
    imageFormat: 'file_uploader.image_format',
    dimensions: 'file_uploader.dimensions',
    deleteFile: 'file_uploader.delete_file',
    toSearchIt: 'file_uploader.search_it',
    correctedFile: 'button.upload_corrected_file'
  },
  copyright: 'csp.footer',
  privacyPolicy: 'global.privacy_policy',
  termsAndConditions: 'global.terms_and_conditions',
  siteProtection: 'csp.site_protection',
  recaptcha: 'global.recaptcha_protected.main',
  imageCard: {
    buttonDetail: 'button.see_detail'
  },
  dateSelector: {
    last12Months: 'csp.last_12_months',
    theLast12Months: 'csp.the_last_12_months',
    monthly: 'csp.monthly',
    historical: 'csp.historical'
  },
  downloadMonthlyReport: {
    button: 'metrics.button.download_report',
    loading: 'download_monthly_report.loading',
    errorModal: {
      title: 'metrics.monthly_report.current_month_errror.title',
      description: 'metrics.monthly_report.current_month_errror.description',
      button: 'button.understood'
    }
  },
  coverage: 'csp.coverage',
  header: {
    profileMenu: {
      settings: 'profile_menu.title',
      account: 'profile_menu.item.account',
      organization: 'profile_menu.item.organization',
      integrations: 'profile_menu.item.integrations',
      language: 'profile_menu.item.language',
      logout: 'profile_menu.log_out'
    },
    companySelector: {
      title: 'company_menu.title',
      button: 'global.button.select'
    }
  },
  errorCard: {
    title: 'global.service_error.title',
    description: 'global.service_error.description',
    buttonText: 'csp.retry'
  },
  seeMore: 'global.see_more.button',
  seeLess: 'global.see_less.button',
  available: 'global.available.main',
  totalHealthBenefits: 'global.total_benefits_health.main',
  totalDependents: 'global.family_addon_total.description',
  dependents: 'global.family_addon.main',
  totalWellbeingBenefits: 'global.total_benefits_wellbeing.main',
  fileDropzone: {
    fileTitle: 'global.upload_file_input.placeholder',
    formatDescription: 'collaborators.add_collaborators.upload_file_input.format_description',
    correctedFile: 'global.upload_file.reset_file.button',
    loading: {
      title: 'global.upload_file_input.loading'
    }
  },
  notInformed: 'global.not_informed.main'
};
